export enum TitleBarTheme {
  'white' = 'white',
  'black' = 'black',
}
type TitleBarProps = {
  title: string[]
  desc?: string[]
  descInline?: boolean
  theme?: TitleBarTheme
  titleTag?: HeadingTag
}

const TitleBar: React.FC<TitleBarProps> = ({ title, desc, descInline, theme = TitleBarTheme.white, titleTag }) => {
  return (
    <div className={['mb-8 laptop:mb-64px'].join(' ')}>
      {/* title */}
      <div className={[].join(' ')}>
        {title?.map((item, index) => (
          <SemanticText
            key={index}
            as={titleTag}
            defaultTag="h3"
            className={[
              theme === TitleBarTheme.white ? 'text-white/90' : 'text-black/90',
              ' text-24 font-semibold',
              'laptop:text-center laptop:text-48',
            ].join(' ')}
          >
            {item}
          </SemanticText>
        ))}
      </div>
      {/* desc */}
      {desc && (
        <div
          className={[
            'mt-3 flex flex-col',
            'laptop:flex-row laptop:mt-6 laptop:relative',
            'laptop:justify-center',
          ].join(' ')}
        >
          <div className={['w-full', 'laptop:w-200'].join(' ')}>
            {descInline ? (
              <p
                className={[
                  theme === TitleBarTheme.white ? 'text-white/90' : 'text-black/90',
                  ' text-16',
                  'laptop:text-18',
                  'laptop:text-center',
                ].join(' ')}
              >
                {desc?.map((item) => item)}
              </p>
            ) : (
              desc?.map((item, index) => (
                <p
                  key={index}
                  className={[
                    theme === TitleBarTheme.white ? 'text-white/90' : 'text-black/90',
                    ' text-16',
                    'laptop:text-18',
                    'laptop:text-center',
                  ].join(' ')}
                >
                  {item}
                </p>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  )
}
export default TitleBar
import { HeadingTag } from '../../common/pd-meta-components-types'
import SemanticText from '../standard/semantic-text'
